import React, { useState } from 'react';
import AuthModal from '../components/AuthModal';
import { useNavigate } from 'react-router-dom';
import { Sparkles, TrendingUp, Zap, Heart } from 'lucide-react';

const Auth = () => {
  const [showModal, setShowModal] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    setShowModal(false);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#FFFDF5] flex items-center justify-center p-6">
      <div className="max-w-4xl w-full text-center">
        <div className="mb-12">
          <h1 className="text-6xl md:text-8xl font-bold mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
            Join the Fun
          </h1>
          <p className="text-2xl text-gray-600 mb-8">
            Bookmark your favorite wit and never miss a laugh
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white border-2 border-black rounded-xl p-6 hard-shadow-lg">
            <div className="bg-[#FF6B6B] w-12 h-12 rounded-full border-2 border-black flex items-center justify-center mx-auto mb-4">
              <Sparkles className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Merriweather, serif' }}>
              Daily Updates
            </h3>
            <p className="text-gray-600">Fresh humorous news every day</p>
          </div>

          <div className="bg-white border-2 border-black rounded-xl p-6 hard-shadow-lg">
            <div className="bg-[#4ECDC4] w-12 h-12 rounded-full border-2 border-black flex items-center justify-center mx-auto mb-4">
              <Heart className="w-6 h-6 text-black" strokeWidth={2.5} />
            </div>
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Merriweather, serif' }}>
              Save Favorites
            </h3>
            <p className="text-gray-600">Save the best wit</p>
          </div>

          <div className="bg-white border-2 border-black rounded-xl p-6 hard-shadow-lg">
            <div className="bg-[#FFE66D] w-12 h-12 rounded-full border-2 border-black flex items-center justify-center mx-auto mb-4">
              <Zap className="w-6 h-6 text-black" strokeWidth={2.5} />
            </div>
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Merriweather, serif' }}>
              Quick Reads
            </h3>
            <p className="text-gray-600">3-5 lines max per story</p>
          </div>
        </div>
      </div>

      {showModal && <AuthModal onClose={handleClose} />}
    </div>
  );
};

export default Auth;